<app-header [title]="title" [subtitle]="subtitle"></app-header>
<main>
  <div class="row">
    <div class="col-lg-12">
      <p class="info"  >
        Tynk mozaikowy jest uzupełnieniem głównego tynku fasadowego. Podkreśla detale elewacji jednocześnie zabezpieczając
        je przed
        zabrudzeniami. Tynk Knauf Mosaic dostępny jest w 48 kolorach - wybierz ten, który najlepiej pasuje do Twojej
        kompozycji kolorystycznej.
      </p>
    </div>
    </div>

  <div class="row">
    <div class="plaster col-lg-3 col-xs-12">
      <h2  >TWOJA KOMPOZYCJA</h2>
      <div class="details">
        <h1>Miejski szyk</h1>
        <div class="colors">
          <div class="color" *ngFor="let color of project.selectedColors"> <span
              [ngStyle]="{'background': color.rgb}"></span><em>{{color.code}}</em></div>
        </div>
        <div *ngIf="selectedMosaic">
          <h3>Tynk mozaikowy</h3>
          <div class="colors">
            <div class="color"><img src="{{selectedMosaic.file}}" alt=""> <em>{{selectedMosaic.code}}</em></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mosaic col-lg-9 col-xs-12">
      <div class="leaning info-button" (mouseover)="onMosaicInfo(true)" (mouseout)="onMosaicInfo(false)">
        <div class="content">
          <img src="assets/photos/info-button.png" alt="Informacje o palecie">
        </div>
      </div>
      <div class="leaning palette-desc" [ngStyle]="{'display': showMosaicInfo ? 'block' : 'none'}">
        <div class="content">Kolor mozaiki dopasuj do tynku głównego oraz kolorystyki dachu, stolarki okiennej i drzwiowej</div>
      </div>
      <h2  >WYBIERZ KOLOR TYNKU MOZAIKOWEGO</h2>
      <div class="details">
        <div class="colors">
          <span class="color" *ngFor="let color of mosaic_set" (click)="onMosaicSelect(color)"
            [ngClass]="{'selected': selectedMosaic == color}"><img src="{{color.file}}"
              alt=""><em>{{color.code}}</em></span>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>
